var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [
        _vm._v("特定商取引法に基づく表示")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", { attrs: { id: "tokutei" } }, [
              _c("section", [
                _c("div", { ref: "corp_yasumoku", staticClass: "corp_table" }, [
                  _vm._m(0)
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "border_line" } }),
                _vm._v(" "),
                _c("div", { ref: "corp_candeal", staticClass: "corp_table" }, [
                  _vm._m(1)
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("株式会社ヤスモク")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("安田知弘")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("〒501-4202 岐阜県郡上市八幡町市島18-1")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("0575-62-2311")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("info@yasumoku.jp")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "https://yasumoku.jp",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("https://yasumoku.jp")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・配送料"),
          _c("br"),
          _vm._v(
            "\n                  ・組立設置等のサービス料（ご選択された場合）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  クレジットカード、金融機関でのお支払い\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v("\n                  ご注文時に決済となります。"),
          _c("br")
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 金融機関でのお支払い 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文より7日以内にお振込みをお願いいたします。"
          ),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の引渡時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("返品・交換")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  オーダー家具のため、注文後のキャンセルはできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。"
          ),
          _c("br"),
          _vm._v("\n                  ・商品に瑕疵がある場合"),
          _c("br"),
          _vm._v(
            "\n                  ・商品説明と実際の商品が明らかに異なる場合"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・梱包の不備により配送時に商品が破損した場合"
          ),
          _c("br"),
          _vm._v("\n                  ・その他の商品の不具合\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("株式会社キャンディルテクト")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("三浦 翔")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("東京都江東区常盤1-2-5")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("03-5625-4587")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("te_hp@candeal.co.jp")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "https://candeal-tect.co.jp",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("https://candeal-tect.co.jp")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("サービスの販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("サービス以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  組立設置オプションには以下の費用が発生します。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・組立技術料：組立作業費および副資材、簡易養生材など。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・諸経費：交通費、燃料代など。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  ・クレジットカード決済、金融機関でのお支払い"
          ),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文時に決済となります。\n                "
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 金融機関でのお支払い 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文より7日以内にお振込みをお願いいたします。"
          ),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("サービスの開始・完成時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  工事の開始時期及び完成時期は、別途お客様と合意した時期といたします。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ※地域（離島、遠隔地等）または時期（年末年始・夏季休業等）によっては通常より日数をいただく場合がございます。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ご注文のキャンセル")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  組立設置サービス契約の締結後は当該契約の解除（キャンセル）及び代金の返金はできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  詳細は利用規約第１１条をご覧ください。\n                "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbcf76f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbcf76f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcTokutei.vue
// module id = null
// module chunks = 